module.exports = __webpack_public_path__ + "img/red_typo.1224914d.png";